import { authorizedFetch } from '../utils/api';

/**
 * OtterService - Otter-Schrank (Aura v2, Okt 2026), Backend /api/v1/otter.
 *
 * Alle Methoden werfen bei einem Fehler (HTTP oder Netz); die Aufrufer
 * entscheiden, ob das still bleibt (Nachholen der Freischaltungen) oder
 * sichtbar wird (Anziehen im Schrank).
 */
const request = async (path, options = {}) => {
  const response = await authorizedFetch(`/api/v1/otter${path}`, options);
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok || (body && body.success === false)) {
    const error = new Error(body?.error || `Otter-Schrank: HTTP ${response.status}`);
    error.status = response.status;
    error.code = body?.code;
    throw error;
  }
  return body || {};
};

const OtterService = {
  /** Schrank: { enabled, unlocked, catalog, hiddenCount, outfit, otterVisible } */
  getWardrobe: () => request(''),

  /** Ungesehene Freischaltungen: { enabled, unlocked: [{ kind, key, unlockedAt, seenAt }] } */
  getUnseen: () => request('/unseen'),

  /** Freischaltungen als gesehen markieren */
  markSeen: (keys) => {
    const list = [...new Set((keys || []).filter(Boolean))];
    if (list.length === 0) return Promise.resolve({ updated: 0 });
    return request('/seen', { method: 'POST', body: JSON.stringify({ keys: list }) });
  },

  /** Outfit speichern ({ slot: achievementKey }) */
  saveOutfit: (outfit) => request('/outfit', { method: 'PUT', body: JSON.stringify(outfit || {}) }),

  /** Duerfen andere den Otter mit Teilen sehen? */
  setVisibility: (visible) => request('/visibility', { method: 'PUT', body: JSON.stringify({ visible: Boolean(visible) }) }),
};

export default OtterService;
